import React, {useEffect, useState} from "react";
import Header from "../components/header/Header";
import Greeting from "./greeting/Greeting";
import Skills from "./skills/Skills";
import StackProgress from "./skillProgress/skillProgress";
import WorkExperience from "./workExperience/WorkExperience";
import Projects from "./projects/Projects";
import Achievement from "./achievement/Achievement";
import MissionLab from "./missionLab/MissionLab";
import DockingSimulator from "../pages/DockingSimulator";
import MemeGenerator from "../pages/MemeGenerator";
import SignalDecoder from "../pages/SignalDecoder";
import Blogs from "./blogs/Blogs";
import Footer from "../components/footer/Footer";
import Talks from "./talks/Talks";
import Podcast from "./podcast/Podcast";
import Education from "./education/Education";
import ScrollToTopButton from "./topbutton/Top";
import Twitter from "./twitter-embed/twitter";
import Profile from "./profile/Profile";
import SplashScreen from "./splashScreen/SplashScreen";
import {splashScreen} from "../portfolio";
import {StyleProvider} from "../contexts/StyleContext";
import {useLocalStorage} from "../hooks/useLocalStorage";
import "./Main.scss";

const OrbitPlayground = React.lazy(() => import("../pages/OrbitPlayground"));

const Main = () => {
  const [isDark, setIsDark] = useLocalStorage("isDark", true);
  const [isShowingSplashAnimation, setIsShowingSplashAnimation] =
    useState(true);
  const [route, setRoute] = useState(() =>
    window.location.hash.indexOf("#/") === 0
      ? window.location.hash.slice(2)
      : ""
  );

  useEffect(() => {
    if (splashScreen.enabled) {
      const splashTimer = setTimeout(
        () => setIsShowingSplashAnimation(false),
        splashScreen.duration
      );
      return () => {
        clearTimeout(splashTimer);
      };
    }
  }, []);

  useEffect(() => {
    const updateRoute = () => {
      const nextRoute =
        window.location.hash.indexOf("#/") === 0
          ? window.location.hash.slice(2)
          : "";
      setRoute(nextRoute);

      if (
        !nextRoute &&
        window.location.hash &&
        window.location.hash.indexOf("#/") !== 0
      ) {
        window.requestAnimationFrame(() => {
          const target = document.querySelector(window.location.hash);
          if (target) target.scrollIntoView();
        });
      } else {
        window.scrollTo(0, 0);
      }
    };
    window.addEventListener("hashchange", updateRoute);
    return () => window.removeEventListener("hashchange", updateRoute);
  }, []);

  useEffect(() => {
    if (route === "docking-simulator") {
      document.title = "Docking Simulator | Avik Banerjee";
    } else if (route === "space-meme-generator") {
      document.title = "Space Meme Generator | Avik Banerjee";
    } else if (route === "signal-decoder") {
      document.title = "Signal Decoder | Avik Banerjee";
    } else if (route === "orbit-playground") {
      document.title = "Orbit Playground | Avik Banerjee";
    } else {
      document.title = "Avik Banerjee | Aerospace Engineer";
    }
  }, [route]);

  const changeTheme = () => {
    setIsDark(!isDark);
  };

  return (
    <div className={isDark ? "portfolio-shell dark-mode" : "portfolio-shell"}>
      <StyleProvider value={{isDark: isDark, changeTheme: changeTheme}}>
        {route === "docking-simulator" ? (
          <DockingSimulator />
        ) : route === "space-meme-generator" ? (
          <MemeGenerator />
        ) : route === "signal-decoder" ? (
          <SignalDecoder />
        ) : route === "orbit-playground" ? (
          <React.Suspense
            fallback={
              <main className="orbit-loading-page" aria-live="polite">
                Opening Orbit Playground…
              </main>
            }
          >
            <OrbitPlayground />
          </React.Suspense>
        ) : isShowingSplashAnimation && splashScreen.enabled ? (
          <SplashScreen />
        ) : (
          <>
            <Header />
            <Greeting />
            <Skills />
            <StackProgress />
            <Education />
            <WorkExperience />
            <Projects />
            <Achievement />
            <MissionLab />
            <Blogs />
            <Talks />
            <Twitter />
            <Podcast />
            <Profile />
            <Footer />
            <ScrollToTopButton />
          </>
        )}
      </StyleProvider>
    </div>
  );
};

export default Main;
